<script setup lang="ts">
import type { HTMLAttributes } from "vue"
import { PinInputRoot, type PinInputRootEmits, type PinInputRootProps, useForwardPropsEmits } from "radix-vue"
import { useClass } from "~/composables/local/cn-class"

const {
	modelValue = [],
	class: rawClass,
	...props
} = defineProps<PinInputRootProps & { class?: HTMLAttributes["class"] }>()
const emits = defineEmits<PinInputRootEmits>()

const forwarded = useForwardPropsEmits(() => props, emits)

const className = useClass(
	"flex gap-2 items-center",
	() => rawClass,
)
</script>

<template>
	<PinInputRoot
		:model-value="modelValue"
		v-bind="forwarded"
		:class="className">
		<slot />
	</PinInputRoot>
</template>
